import styled from 'styled-components';

/**
 * This wrapper prevents a layout shift when used in a `ModalDialog`, at the bottom of a long
 * scrollable body content. [CDS-1182](https://zbrt.atl.zillow.net/browse/CDS-1182)
 *
 * @since 8.65.1
 */

var SwitchWrapper = /*#__PURE__*/styled('div').withConfig({
  displayName: "SwitchWrapper",
  componentId: "c11n-8-107-0__sc-117vvp2-0"
})(["position:relative;"]);
SwitchWrapper.displayName = 'SwitchWrapper';

/** @component */
export { SwitchWrapper };